import { useState, useCallback } from 'react';
import { d214Api, FC170 } from '../../../services/d214Api';

export function useD214Navigation() {
  const [list, setList] = useState<{ scNo: string; itemNo: number }[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  const fetchList = useCallback(async (keyword?: string) => {
    try {
      const result = await d214Api.list(1, 200, keyword);
      const ids = result.data.map((r: FC170) => ({ scNo: r.fc170_01, itemNo: r.fc170_02 }));
      setList(ids);
      return ids;
    } catch {
      return [];
    }
  }, []);

  const setCurrentByKey = useCallback((scNo: string, itemNo: number) => {
    const idx = list.findIndex(i => i.scNo === scNo && i.itemNo === itemNo);
    if (idx >= 0) setCurrentIdx(idx);
  }, [list]);

  const hasPrev = currentIdx > 0;
  const hasNext = currentIdx >= 0 && currentIdx < list.length - 1;

  const goFirst = useCallback(() => {
    if (list.length === 0) return null;
    setCurrentIdx(0);
    return list[0];
  }, [list]);

  const goLast = useCallback(() => {
    if (list.length === 0) return null;
    const idx = list.length - 1;
    setCurrentIdx(idx);
    return list[idx];
  }, [list]);

  const goPrev = useCallback(() => {
    if (!hasPrev) return null;
    const idx = currentIdx - 1;
    setCurrentIdx(idx);
    return list[idx];
  }, [hasPrev, currentIdx, list]);

  const goNext = useCallback(() => {
    if (!hasNext) return null;
    const idx = currentIdx + 1;
    setCurrentIdx(idx);
    return list[idx];
  }, [hasNext, currentIdx, list]);

  return { list, currentIdx, hasPrev, hasNext, fetchList, setCurrentByKey, goFirst, goLast, goPrev, goNext };
}
